import { RiTerminalBoxLine } from '@remixicon/react';

import {
  createArtifactExtension,
  isCodingSessionArtifact,
} from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';
import {
  CodingSessionArtifactContent,
  CodingSessionArtifactListItem,
} from './CodingSessionArtifactItems';

export const CodingSessionArtifactExtension = projectsPlugin.provide(
  createArtifactExtension({
    id: 'coding-session',
    predicate: isCodingSessionArtifact,
    icon: () => ({
      Icon: RiTerminalBoxLine,
      color: 'var(--text-base)',
    }),
    label: 'Coding session',
    category: 'Coding sessions',
    render: artifact => <CodingSessionArtifactContent artifact={artifact} />,
    renderListItem: (artifact, { onDelete, onRename, icon }) => (
      <CodingSessionArtifactListItem
        artifact={artifact}
        icon={icon}
        onDelete={onDelete}
        onRename={onRename}
      />
    ),
  }),
);
